<div class="s-form-field">
  <label [for]="id()" class="s-form-field--label"
    >{{ label() }}
    @if (errorType() === 'text' || errorType() === 'outline-plus-text') {
    <div class="s-form-field--error">{{ error() }}</div>
    }
  </label>
  <div class="s-form-field--input-container">
    <input
      class="s-form-field--input"
      [type]="typeof value() === 'number' ? 'number' : 'text'"
      [id]="id()"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      (input)="value.set($event.target.value)"
    />
  </div>
</div>
